import {
  Localizations
} from 'localize'

Localizations.append({
  modules: {
    cart: {
      components: {
        shoppingCart: {
          title: 'Your cart',
          continueShopping: 'Continue shopping',
          proceed: 'Proceed to checkout',
          error: 'We couldn\'t load your shopping cart. Please refresh the page and try again.'
        },
        prices: {
          subtotal: 'Subtotal',
          discount: 'Discount',
          shipping: 'Shipping',
          free: 'Free',
          tax: 'Tax',
          total: 'Total',
          includesTaxes: 'Includes taxes',
          automatictaxes: 'Actual tax amount depends on your shipping address'
        },
        discount: {
          title: 'Discount code',
          enter: 'Enter discount code',
          cancel: 'Cancel discount code',
          clear: 'Clear discount code',
          invalid: 'Discount code is invalid',
          applied: 'Discount applied ({0} off)',
          appliedFreeShipping: 'Discount applied (Free shipping)'
        }
      }
    }
  }
})
